//
function getTarget(event, selector) {
    if (event.target.closest(selector)) {
        return event.target.closest(selector);
    }
}

export { getTarget };
